// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"b98a5150","588":"9796df13","821":"8cacdb7a"}[chunkId] + ".chunk.js";
};